/**
 * Reveal
 * Alerts
 * @author Oliver Boermans
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'reveal';
const log = debug(MODULE_NAME);

//	Elements
const NOTICE_PLACEHOLDER_SELECT = 'div[data-site-notice-placeholder]';
const NOTICE_SELECT = 'div[data-site-notice]';

//
// Initialise
// ===========
export default function run (){
	log('Running…');
	const alertBar = $(NOTICE_SELECT);

	if (!alertBar.length) {

		log('No alert to reveal. Bye…');
		return false;

	}

	const alertPlace = $(NOTICE_PLACEHOLDER_SELECT);

	//	Copy alert into placeholder
	alertBar.children().clone().appendTo(alertPlace);
	log('…complete');
};




// WEBPACK FOOTER //
// ./project/client/src/core/modules/alerts/reveal.js